// Monta e lê o contexto da OS no apontamento. Sem estes parâmetros a tela
// não pode inventar OP-1042 — o operador precisa identificar a OS de verdade.

export interface ContextoApontamento {
  readonly osId: string;
  readonly opNumero?: string;
  readonly etapaOrdem?: string;
  readonly celulaId?: string;
}

export function montarUrlApontamento(ctx: ContextoApontamento): string {
  const q = new URLSearchParams();
  q.set('osId', ctx.osId);
  if (ctx.opNumero) q.set('opNumero', ctx.opNumero);
  if (ctx.etapaOrdem) q.set('etapaOrdem', ctx.etapaOrdem);
  if (ctx.celulaId) q.set('celulaId', ctx.celulaId);
  return `/coletor/apontamento?${q.toString()}`;
}

export function lerContextoApontamento(search: string): ContextoApontamento | null {
  const raw = search.startsWith('?') ? search.slice(1) : search;
  const q = new URLSearchParams(raw);
  const osId = q.get('osId')?.trim() ?? '';
  if (!osId) return null;
  return {
    osId,
    opNumero: q.get('opNumero')?.trim() || undefined,
    etapaOrdem: q.get('etapaOrdem')?.trim() || undefined,
    celulaId: q.get('celulaId')?.trim() || undefined,
  };
}
